// Tenant Admin renders the selected panel from route metadata rather than a
// nested <RouterView>, but Vue Router still requires a component on each
// canonical child route.
const RouteState = { render: () => null };

const entityConfigurationRoute = (path, name, entityConfigurationTab) => ({
  path,
  name,
  component: RouteState,
  meta: { adminTab: 'Entity Configuration', entityConfigurationTab },
});

export const ENTITY_CONFIGURATION_ROUTES = [
  entityConfigurationRoute(
    'entity-management/configuration',
    'AdminEntityConfigurationTypes',
    'configuration'
  ),
  entityConfigurationRoute(
    'entity-management/creator',
    'AdminEntityConfigurationCreator',
    'creator'
  ),
  entityConfigurationRoute(
    'entity-management/user-assignments',
    'AdminEntityConfigurationUserAssignments',
    'user-assignments'
  ),
  entityConfigurationRoute(
    'entity-management/relationships',
    'AdminEntityConfigurationRelationships',
    'relationships'
  ),
  entityConfigurationRoute(
    'entity-management/classification',
    'AdminEntityConfigurationClassification',
    'classification'
  ),
  entityConfigurationRoute(
    'entity-management/scorecard-metrics',
    'AdminEntityConfigurationScorecardMetrics',
    'scorecard-metrics'
  ),
];
